import { Directive, OnDestroy } from '@angular/core';

export type TimeOutId = ReturnType<typeof setTimeout>;

@Directive({})
export abstract class ClearTimeoutAbstractComponent implements OnDestroy {
  private timeOutIDs: TimeOutId[] = [];

  protected addTimeOutIdToClearOnDestroy(idToAdd: TimeOutId): void {
    this.timeOutIDs.push(idToAdd);
  }

  public ngOnDestroy(): void {
    this.timeOutIDs.forEach((id: TimeOutId): void => {
      clearTimeout(id);
    });
  }
}
